import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { IDarkTheme } from "styles/darkTheme";

export const styles = makeStyles((theme: IDarkTheme) =>
  createStyles({
    headerTitle: {
      color: theme.colors.secondary.secondary_50,
      fontSize: theme.fontSize.heading_7,
      lineHeight: theme.fontSize.heading_7,
      fontWeight: theme.fontWeight.bold,
      fontFamily: theme.fontFamily.montserrat,
      margin: "2rem 0rem 1rem 0.5rem"
    },
    planFlexContainer: {
      paddingInline: "1rem",
      borderRadius: "0.5rem",
      height: "2.875rem"
    },
    planLabel: {
      color: "#92979C",
      fontSize: theme.fontSize.bodyText_2,
      lineHeight: theme.fontSize.heading_4,
      fontWeight: theme.fontWeight.medium,
      fontFamily: theme.fontFamily.montserrat
    },
    planValue: {
      alignSelf: "center",
      color: theme.colors.secondary.secondary_50,
      fontSize: theme.fontSize.heading_9,
      lineHeight: theme.fontSize.heading_4,
      fontWeight: theme.fontWeight.medium,
      fontFamily: theme.fontFamily.montserrat
    },
    cancelButton: {
      color: "#969696",
      border: "0.063rem solid #969696"
    },
    submitButton: {
      backgroundColor: theme.colors.secondary.secondary_50
    },
    modalButton: {
      width: "13.75rem",
      height: "3rem",
      fontFamily: theme.fontFamily.montserrat,
      fontWeight: theme.fontWeight.medium,
      fontSize: theme.fontSize.bodyText_1,
      lineHeight: theme.fontSize.heading_8,
      borderRadius: "0.5rem",
      textTransform: "none"
    },
    cancelSubscriptionButton: {
      alignSelf: "end",
      textTransform: "none",
      color: theme.colors.semantic.semantic_grey,
      border: "none",
      fontFamily: theme.fontFamily.montserrat,
      fontSize: theme.fontSize.bodyText_3,
      lineHeight: theme.fontSize.heading_9,
      fontWeight: theme.fontWeight.medium
    },
    cancellationDismissButton: {
      textTransform: "none",
      color: theme.colors.secondary.secondary_50,
      borderRadius: "0.25rem",
      border: `0.063rem solid ${theme.colors.secondary.secondary_50}`,
      fontFamily: theme.fontFamily.montserrat,
      fontSize: theme.fontSize.bodyText_3,
      lineHeight: theme.fontSize.heading_5,
      fontWeight: theme.fontWeight.big
    },
    cancellationSubmitButton: {
      color: theme.colors.semantic.semantic_white,
      backgroundColor: theme.colors.secondary.secondary_50
    },
    cancellationDescription: {
      textAlign: "center",
      fontFamily: theme.fontFamily.montserrat,
      fontSize: theme.fontSize.bodyText_2,
      lineHeight: theme.fontSize.heading_8,
      fontWeight: theme.fontWeight.regular
    },
    cancellationHeader: {
      fontFamily: theme.fontFamily.montserrat,
      fontSize: theme.fontSize.bodyText_1,
      lineHeight: theme.fontSize.heading_4,
      fontWeight: theme.fontWeight.big
    }
  })
);

export default styles;
